import React, { useEffect, useState } from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import * as Config from '@/config'
import { logout } from '@/api/login';
import { useUserStore } from '@/stores/user';
import { useLoadingStore } from '@/stores/loading';
import ConfirmModal from './ConfirmModal';

export default function Header() {
  const navigate = useNavigate();
  const pathname = useLocation().pathname;
  const setUser = useUserStore((state) => state.setUser);
  const setLoading = useLoadingStore((state) => state.setLoading);
  const [modalConfirm, setModalConfirm] = useState<{ callback: () => void } | undefined>(undefined);

  const isLoginPage = pathname === "/" || pathname === "/login";

  const onClickLogout = () => {
    setModalConfirm({
      callback: async () => {
        setLoading(true);
        try {
          await logout();
          setUser(undefined);
          navigate('/login');
        } catch (error) {
          console.error('ログアウトに失敗しました', error);
        } finally {
          setLoading(false);
        }
      }
    });
  };

  // const onClickUser = () => {
  //   navigate('/password_change', { state: { is_changed: true } });
  // }

  console.log(pathname);

  return (
    <>
      <header className="uk-flex-between">
        <div>
          <div className="uk-flex uk-flex-middle uk-flex-between">
            <div className="uk-flex uk-flex-middle">
              <a href="https://www.drm.jp" target="_blank" rel="noreferrer noopener">
                <img src={require('../assets/images/logo.png')}
                    alt="一般財団法人日本デジタル道路地図協会"/>
              </a>
              <span className="uk-text-small uk-margin-small-left">一般財団法人</span>
              <span className="text-medium uk-margin-small-left">日本デジタル道路地図協会</span>
              {Config.HEADER_ENV !== "" && <span className="uk-margin-small-left env-label">{Config.HEADER_ENV}</span>}
            </div>
          </div>
        </div>
        {!isLoginPage && (
            <button
              className="uk-button--m uk-button-cancel uk-margin-right"
              onClick={onClickLogout}
            >
              ログアウト
            </button>
        )}
      </header>
      <div className={`${isLoginPage ? "login-header": ""} bg-city-img uk-flex uk-flex-center uk-flex-middle`}>
        <h1 className="uk-text-bold">マイページ</h1>
      </div>
      <ConfirmModal
        text={Config.MESSAGE_NO_E25}
        confirmButtonText="OK"
        isShow={modalConfirm !== undefined}
        onConfirm={() => {
          if (modalConfirm) modalConfirm.callback();
          setModalConfirm(undefined);
        }}
        onCancel={() => {
          setModalConfirm(undefined);
        }}
      />
    </>

  );
}
